import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import OriginalMessageService from "./service/originalMessageService";
import {OriginalMessageDOI} from "./api/originalMessageApi";
import override from 'src/dectorators/override';
import {Component, Prop} from 'vue-property-decorator'

@Component({name: 'original-message'})
export default class OriginalMessage extends BasicSearchPage<OriginalMessageService, OriginalMessageDOI.RowDataI, OriginalMessageDOI.QueryRowDataParamsI>{
    @override
    renderHead(h) {
        return <div></div>
    }

	@override
	loadService () {
		this.service = new OriginalMessageService(this)
	}
}